export enum DatasheetFieldComponentHeadingPosition {
  top = 0,
  left = 1,
  bottom = 2,
  right = 3,
}